import { useNavigate, useParams } from "react-router-dom";
import RightWrapper from "../../../Components/CommonComponents/ComponentWrapper";
import axios from "axios";
import { END_POINT, getJwtToken } from "../../../Redux/AdminReducer/action";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FiArrowLeft } from "react-icons/fi";
import CustomSpinner from "../../../Components/CommonComponents/CustomSpinner";
import TherapyRequestDetails, { OriginBadge, StatusBadge } from "../Alternative_Therapies/TherapyRequestDetails";


const fetchItems = async (path) => {
  try {
    const result = await axios.get(`${END_POINT}/${path}`, 
      {headers: {
        Authorization: getJwtToken(),
      },}
    );
    return result;
  } catch (error) {
    toast.error(error?.response?.data || "Something went wrong");
    console.log(error);

    toast.error("Something went wrong while fetching data");
  }
};

const Bids = () => {
  const { bid_id } = useParams();
  const [formData, setFormData] = useState();
  const nav = useNavigate();

  useEffect(() => {
    fetchItems(`alternative_therapy/getForm/${bid_id}`).then((e) => {
      setFormData(e?.data);
    });
  }, [bid_id]);

  const meta = [
    { label: 'Consultant', value: formData?.consultant?.name },
    { label: 'Agreed Price', value: formData?.bidPrice != null ? formData.bidPrice : null },
    { label: 'Agreed Duration', value: formData?.bidDuration != null ? `${formData.bidDuration} days` : null },
  ].filter((m) => m.value !== null && m.value !== undefined && m.value !== '');

  return (
    <RightWrapper>
      <div className="w-full px-2 py-4 md:px-4">
        {/* Page header */}
        <div className="mb-6 flex flex-wrap items-center gap-3">
          <button
            type="button"
            onClick={() => nav(-1)}
            aria-label="Go back"
            className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 shadow-sm transition hover:bg-slate-100 hover:text-slate-900"
          >
            <FiArrowLeft className="h-4 w-4" />
          </button>
          <div className="min-w-0">
            <h1 className="truncate text-xl font-semibold capitalize tracking-tight text-slate-900">
              {formData?.therapy || 'Therapy Request'}
            </h1>
            <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-slate-500">
              <span>Alternative Therapies</span>
              <StatusBadge status={formData?.status} />
              <OriginBadge origin={formData?.origin} />
            </div>
          </div>
        </div>

        {formData ? (
          <div className="space-y-6">
            {/* Agreement summary */}
            {meta.length > 0 && (
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
                {meta.map((m) => (
                  <div key={m.label} className="rounded-2xl border border-slate-200 bg-white px-4 py-3 shadow-sm">
                    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">{m.label}</p>
                    <p className="mt-1 text-sm font-semibold text-slate-900">{m.value}</p>
                  </div>
                ))}
              </div>
            )}

            <TherapyRequestDetails requestForm={formData?.requestForm} />

            {/* Doctor's brief to the bidders */}
            <section className="rounded-2xl border border-slate-200 bg-white shadow-sm">
              <div className="border-b border-slate-200 px-6 py-4">
                <h2 className="text-sm font-semibold tracking-tight text-slate-900">Request Brief</h2>
              </div>
              <div className="grid grid-cols-1 gap-x-8 gap-y-4 px-6 py-5 sm:grid-cols-3">
                <div>
                  <p className="text-xs font-medium uppercase tracking-wide text-slate-500">Expected Duration</p>
                  <p className="mt-1 text-sm font-medium text-slate-900">
                    {formData?.duration ? `${formData.duration} days` : '—'}
                  </p>
                </div>
                <div className="sm:col-span-2">
                  <p className="text-xs font-medium uppercase tracking-wide text-slate-500">Note</p>
                  <p className="mt-1 whitespace-pre-wrap text-sm text-slate-900">{formData?.note || '—'}</p>
                </div>
              </div>
            </section>
          </div>
        ) : (
          <CustomSpinner />
        )}
      </div>
    </RightWrapper>
  );
};

export default Bids;
